var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* 06/15/2020 - Dennis

	The class defined here will be responsible for keeping in memory the many attributes
	that will be used across multiple objects. For that, the localStorage class will be used.
	
	Things that will be held in localStorage
	
	 - Custom Scenario data for personalized quotes
	 - User selected product with quotes

*/
import React, { Component } from "react";
import ProductDetails from "./ProductDetails";

var UserSession = function (_Component) {
	_inherits(UserSession, _Component);

	function UserSession(props) {
		_classCallCheck(this, UserSession);

		var _this = _possibleConstructorReturn(this, (UserSession.__proto__ || Object.getPrototypeOf(UserSession)).call(this, props));

		_this.loadCustomQuoteData();

		return _this;
	}

	_createClass(UserSession, [{
		key: "componentDidMount",
		value: function componentDidMount() {
			if (!React.version.startsWith('17')) {
				console.error("UserSession requires react version 17.0.2 in order to avoid react hook error. The current version of react is " + React.version);
			}
		}
	}, {
		key: "render",
		value: function render() {
			return null;
		}
	}, {
		key: "loadCustomQuoteData",
		value: function loadCustomQuoteData() {
			/* When the class is loaded make sure get read first from the local storage if nothing is found then set default.
   	*/
			this.customQuote = localStorage.getItem("customQuote") || false;
			this.loanPurpose = localStorage.getItem("loanPurpose") || 1;
			this.loanPurposeCode = localStorage.getItem("loanPurposeCode") || "FULL DOCS REFI";
			this.purchasePrice = localStorage.getItem("purchasePrice") || 0.00;
			this.downPaymentAmount = localStorage.getItem("downPaymentAmount") || 0.00;
			this.propertyZipCode = localStorage.getItem("propertyZipCode") || "";
			this.propertyState = localStorage.getItem("propertyState") || "";
			this.propertyCounty = localStorage.getItem("propertyCounty") || "";
			this.propertyCountyName = localStorage.getItem("propertyCountyName") || "";
			this.creditScore = localStorage.getItem("creditScore") || 0;
			this.propertyType = localStorage.getItem("propertyType") || "";
			this.propertyTypeUnits = localStorage.getItem("propertyTypeUnits") || "";
			this.propertyUse = localStorage.getItem("propertyUse") || 0;
			this.propertyUseCode = localStorage.getItem("propertyUseCode") || "";
			this.veteran = localStorage.getItem("veteran") || false;
			this.noClosingCosts = localStorage.getItem("noClosingCosts") || false;
			this.estimatedValue = localStorage.getItem("estimatedValue") || 0.00;
			this.currentLoanBalance = localStorage.getItem("currentLoanBalance") || 0.00;
			this.cashoutAmount = localStorage.getItem("cashoutAmount") || 0.00;
			this.leadSource = localStorage.getItem("leadSource") || "";
			this.branchCode = localStorage.getItem("branchCode") || "";
			this.promoCode = localStorage.getItem("promoCode") || "";
			this.stateList = localStorage.getItem("stateList") || "";

			//store entire response of price-scenario api
			this.webOffer = localStorage.getItem("webOffer") || "";

			//Contact Info
			this.firstName = localStorage.getItem("firstName") || "";
			this.middleName = localStorage.getItem("middleName") || "";
			this.lastName = localStorage.getItem("lastName") || "";
			this.phone = localStorage.getItem("phone") || "";
			this.workPhone = localStorage.getItem("workPhone") || "";
			this.email = localStorage.getItem("email") || "";

			//Product details
			this.selectedProduct = localStorage.getItem("selectedProduct") || new ProductDetails();
			this.selectedProduct.loadSelectedProductData();
		}
	}, {
		key: "clearData",
		value: function clearData() {
			localStorage.clear();
		}
	}, {
		key: "getSelectedProduct",
		value: function getSelectedProduct() {
			return this.selectedProduct;
		}
	}, {
		key: "setCustomQuote",
		value: function setCustomQuote(prop) {
			this.customQuote = prop;
			localStorage.setItem("customQuote", this.customQuote);
		}
	}, {
		key: "getCustomQuote",
		value: function getCustomQuote() {
			return this.customQuote;
		}
	}, {
		key: "setLoanPurpose",
		value: function setLoanPurpose(prop) {
			this.loanPurposeCode = prop;
			localStorage.setItem("loanPurposeCode", prop);
			switch (prop) {
				case "PURCHASE":
					this.loanPurpose = 0;
					localStorage.setItem("loanPurpose", 0);
					break;
				case "FULL DOCS REFI":
					this.loanPurpose = 1;
					localStorage.setItem("loanPurpose", 1);
					break;
				case "CASH OUT REFI":
					this.loanPurpose = 2;
					localStorage.setItem("loanPurpose", 2);
					break;
				//no default
			}
		}
	}, {
		key: "getLoanPurpose",
		value: function getLoanPurpose() {
			return this.loanPurpose;
		}
	}, {
		key: "getLoanPurposeCode",
		value: function getLoanPurposeCode() {
			return this.loanPurposeCode;
		}
	}, {
		key: "setPurchasePrice",
		value: function setPurchasePrice(prop) {
			this.purchasePrice = prop;
			localStorage.setItem("purchasePrice", this.purchasePrice);
		}
	}, {
		key: "getPurchasePrice",
		value: function getPurchasePrice() {
			return this.purchasePrice;
		}
	}, {
		key: "setDownPaymentAmount",
		value: function setDownPaymentAmount(prop) {
			this.downPaymentAmount = prop;
			localStorage.setItem("downPaymentAmount", this.downPaymentAmount);
		}
	}, {
		key: "getDownPaymentAmount",
		value: function getDownPaymentAmount() {
			return this.downPaymentAmount;
		}
	}, {
		key: "setPropertyZipCode",
		value: function setPropertyZipCode(prop) {
			this.propertyZipCode = prop;
			localStorage.setItem("propertyZipCode", this.propertyZipCode);
		}
	}, {
		key: "getPropertyZipCode",
		value: function getPropertyZipCode() {
			return this.propertyZipCode;
		}
	}, {
		key: "setPropertyState",
		value: function setPropertyState(prop) {
			this.propertyState = prop;
			localStorage.setItem("propertyState", this.propertyState);
		}
	}, {
		key: "getPropertyState",
		value: function getPropertyState() {
			return this.propertyState;
		}
	}, {
		key: "setPropertyCounty",
		value: function setPropertyCounty(prop) {
			this.propertyCounty = prop;
			localStorage.setItem("propertyCounty", this.propertyCounty);
		}
	}, {
		key: "getPropertyCounty",
		value: function getPropertyCounty() {
			return this.propertyCounty;
		}
	}, {
		key: "setPropertyCountyName",
		value: function setPropertyCountyName(prop) {
			this.propertyCountyName = prop;
			localStorage.setItem("propertyCountyName", this.propertyCountyName);
		}
	}, {
		key: "getPropertyCountyName",
		value: function getPropertyCountyName() {
			return this.propertyCountyName;
		}
	}, {
		key: "setCreditScore",
		value: function setCreditScore(prop) {
			switch (prop) {
				case "Excellent":
					this.creditScore = 740;
					localStorage.setItem("creditScore", 740);
					break;
				case "VERYGOOD":
					this.creditScore = 739;
					localStorage.setItem("creditScore", 739);
					break;
				case "GOOD":
					this.creditScore = 719;
					localStorage.setItem("creditScore", 719);
					break;
				case "FAIR":
					this.creditScore = 679;
					localStorage.setItem("creditScore", 679);
					break;
				case "POOR":
					this.creditScore = 639;
					localStorage.setItem("creditScore", 639);
					break;
				//no default
			}
		}
	}, {
		key: "getCreditScore",
		value: function getCreditScore() {
			return this.creditScore;
		}
	}, {
		key: "setPropertyType",
		value: function setPropertyType(prop) {
			this.propertyType = prop;
			localStorage.setItem("propertyType", prop);
		}
	}, {
		key: "getPropertyType",
		value: function getPropertyType() {
			return this.propertyType;
		}
	}, {
		key: "setPropertyTypeUnits",
		value: function setPropertyTypeUnits(prop) {
			this.propertyTypeUnits = prop;
			localStorage.setItem("propertyTypeUnits", prop);
		}
	}, {
		key: "getPropertyTypeUnits",
		value: function getPropertyTypeUnits() {
			return this.propertyTypeUnits;
		}
	}, {
		key: "setPropertyUse",
		value: function setPropertyUse(prop) {
			this.propertyUse = prop;
			localStorage.setItem("propertyUse", prop);
			switch (prop) {
				case "1":
					this.propertyUseCode = "OCCUPIED";
					localStorage.setItem("propertyUseCode", "OCCUPIED");
					break;
				case "2":
					this.propertyUseCode = "RENTAL";
					localStorage.setItem("propertyUseCode", "RENTAL");
					break;
				case "3":
					this.propertyUseCode = "SECOND HOME";
					localStorage.setItem("propertyUseCode", "SECOND HOME");
					break;

			}
		}
	}, {
		key: "getPropertyUse",
		value: function getPropertyUse() {
			return this.propertyUse;
		}
	}, {
		key: "getPropertyUseCode",
		value: function getPropertyUseCode() {
			return this.propertyUseCode;
		}
	}, {
		key: "setVeteran",
		value: function setVeteran(prop) {
			this.veteran = prop;
			localStorage.setItem("veteran", prop);
		}
	}, {
		key: "getVeteran",
		value: function getVeteran() {
			return this.veteran;
		}
	}, {
		key: "setNoClosingCosts",
		value: function setNoClosingCosts(prop) {
			this.noClosingCosts = prop;
			localStorage.setItem("noClosingCosts", prop);
		}
	}, {
		key: "getNoClosingCosts",
		value: function getNoClosingCosts() {
			return this.noClosingCosts;
		}
	}, {
		key: "setEstimatedValue",
		value: function setEstimatedValue(prop) {
			this.estimatedValue = prop;
			localStorage.setItem("estimatedValue", prop);
		}
	}, {
		key: "getEstimatedValue",
		value: function getEstimatedValue() {
			return this.estimatedValue;
		}
	}, {
		key: "setCurrentLoanBalance",
		value: function setCurrentLoanBalance(prop) {
			this.currentLoanBalance = prop;
			localStorage.setItem("currentLoanBalance", prop);
		}
	}, {
		key: "getCurrentLoanBalance",
		value: function getCurrentLoanBalance() {
			return this.currentLoanBalance;
		}
	}, {
		key: "setCashOutAmount",
		value: function setCashOutAmount(prop) {
			this.cashoutAmount = prop;
			localStorage.setItem("cashoutAmount", prop);
		}
	}, {
		key: "getCashOutAmount",
		value: function getCashOutAmount() {
			return this.cashoutAmount;
		}
	}, {
		key: "getLeadSource",
		value: function getLeadSource() {
			return this.leadSource;
		}
	}, {
		key: "setLeadSource",
		value: function setLeadSource(prop) {
			this.leadSource = prop;
			localStorage.setItem("leadSource", this.leadSource);
		}
	}, {
		key: "getFirstName",
		value: function getFirstName() {
			return this.firstName;
		}
	}, {
		key: "setFirstName",
		value: function setFirstName(firstName) {
			this.firstName = firstName;
			localStorage.setItem("firstName", this.firstName);
		}
	}, {
		key: "getMiddleName",
		value: function getMiddleName() {
			return this.middleName;
		}
	}, {
		key: "setMiddleName",
		value: function setMiddleName(middleName) {
			this.middleName = middleName;
			localStorage.setItem("middleName", this.middleName);
		}
	}, {
		key: "getLastName",
		value: function getLastName() {
			return this.lastName;
		}
	}, {
		key: "setLastName",
		value: function setLastName(lastName) {
			this.lastName = lastName;
			localStorage.setItem("lastName", this.lastName);
		}
	}, {
		key: "getPhone",
		value: function getPhone() {
			return this.phone;
		}
	}, {
		key: "setPhone",
		value: function setPhone(phone) {
			this.phone = phone;
			localStorage.setItem("phone", this.phone);
		}
	}, {
		key: "getWorkPhone",
		value: function getWorkPhone() {
			return this.workPhone;
		}
	}, {
		key: "setWorkPhone",
		value: function setWorkPhone(workPhone) {
			this.workPhone = workPhone;
			localStorage.setItem("workPhone", this.workPhone);
		}
	}, {
		key: "getEmail",
		value: function getEmail() {
			return this.email;
		}
	}, {
		key: "setEmail",
		value: function setEmail(email) {
			this.email = email;
			localStorage.setItem("email", this.email);
		}
	}, {
		key: "getBranchCode",
		value: function getBranchCode() {
			return this.branchCode;
		}
	}, {
		key: "setBranchCode",
		value: function setBranchCode(branchCode) {
			this.branchCode = branchCode;
			localStorage.setItem("branchCode", this.branchCode);
		}
	}, {
		key: "getPromoCode",
		value: function getPromoCode() {
			return this.promoCode;
		}
	}, {
		key: "setPromoCode",
		value: function setPromoCode(promoCode) {
			this.promoCode = promoCode;
			localStorage.setItem("promoCode", this.promoCode);
		}
	}, {
		key: "getWebOffer",
		value: function getWebOffer() {
			return this.webOffer;
		}
	}, {
		key: "setWebOffer",
		value: function setWebOffer(webOffer) {
			this.webOffer = webOffer;
			localStorage.setItem("webOffer", this.webOffer);
		}
	}, {
		key: "getStateList",
		value: function getStateList() {
			return this.stateList;
		}
	}, {
		key: "setStateList",
		value: function setStateList(stateList) {
			this.stateList = stateList;
			localStorage.setItem("stateList", this.stateList);
		}
	}]);

	return UserSession;
}(Component);

;

export default UserSession;